import { Button, Input, Tooltip, Typography } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { CustomDialog } from "components/CustomDialog";
import { Download } from "components/Logs/Header/Download";
import { translate } from "i18n";
import React, { useState } from "react";
import FileUploadService from "utils/fileuploadservice";

function UploadFile(): React.ReactElement {
    const [selectedFiles, setSelectedFiles] = useState<any[]>([]);
    const [currentFile, setCurrentFile] = useState(undefined);
    const [progress, setProgress] = useState(0);
    const [message, setMessage] = useState("");
    const [dialogOpen, setDialogOpen] = useState(false);
  
    const openRestartConfirmation = () =>{
      setDialogOpen(true);
    }
    const closeRestartConfirmation = () =>{
      setDialogOpen(false);
    }
  
    const selectFile = (event:any) => {
      setSelectedFiles(event.target.files);
    };
  
    const upload = () => {
      if (selectedFiles.length > 0)
      {
      let currentFile = selectedFiles[0];
  
      setProgress(0);
      setCurrentFile(currentFile);
  
      FileUploadService.upload(currentFile, (event:any) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      }).then(() => {
        setDialogOpen(false);
      axios.get(`/maintenance/restart`);
      })
        .catch(() => {
          setProgress(0);
          setMessage("Could not upload the file!");
          setCurrentFile(undefined);
        });
  
      setSelectedFiles([]);
      
      }
    };
  
    return (
      <>        
          <CustomDialog
            title={translate("Restart confirmation logs title")}
            message={translate("Restart confirmation logs text")}
            action={() => upload()}
            open={dialogOpen}
            disableAction={false}
            handleClose={() => closeRestartConfirmation()}
            confirmLabel={"restart"}
          />
            <Tooltip title={translate("Browse")}>
             <Button
              variant="contained"
              component="label"
              style={{ margin: "1em" }}
            >
              ...
              <input
                type="file"
                hidden
                onChange={selectFile}/>
            </Button>
            </Tooltip>
            <Input  value ={selectedFiles.length == 0 ? "" : selectedFiles[0].name}
                    style={{ margin: "1em" }}
                    type="text"/> 
            <Button
              data-cy="maintenance-restore-backup-button"
              style={{ margin: "1em" }}
              variant="contained"
              color="primary"
              disabled={selectedFiles.length == 0}
              onClick={openRestartConfirmation}>
              {translate("Restore Backup")}
            </Button> 
      </>
    );
  };
  
  
  export function BackupRestore () : React.ReactElement {
 
  
    return (
      <>   
        <Box display="flex" flexDirection="column" style={{ marginBottom: "2em" }}>
          <Typography variant="h5" data-cy="maintenance-download-backup-title">
            {translate("Download Backup title")}
          </Typography>
          <Box display="flex" alignItems="center" >
            <Typography variant="h6" data-cy="maintenance-download-backup-text">
              {translate("Download Backup text")}
            </Typography>
            </Box>
              <Box style={{ margin: "1em" }}>
                  <Download unmargined={true} logType={"maintenance/backup"} checkCount={false} />
              </Box>
          </Box>
        <Box display="flex" flexDirection="column" style={{ marginBottom: "2em" }}>
          <Typography variant="h5" data-cy="maintenance-restore-backup-title">
            {translate("Restore Backup title")}
          </Typography>
          <Box display="flex" alignItems="center">
            <Typography variant="h6" data-cy="maintenance-restore-backup-text">
              {translate("Restore Backup text")}
            </Typography>
            </Box>
            <Box display="flex" alignItems="center">
          <UploadFile/>
          </Box>
        </Box>
      </>
    );
  }
